let keyAlgorithm = [
  'RSA',
  'EC'
]

export default keyAlgorithm
